(() => {
	"use strict";

	document.addEventListener("DOMContentLoaded", () => {
		/*======================================
	モーダルの設定
	======================================*/
		MicroModal.init({
			disableScroll: true,
			awaitOpenAnimation: true,
			awaitCloseAnimation: true,

			onShow: () => {
				window.lenis?.stop();
			},

			onClose: () => {
				window.lenis?.start();
			},
		});
	});
})();
